import axios from "axios";
export var clientConfig = {
    baseURL: "https://widgetapi.".concat(process.env.REACT_APP_DOMAIN, "/"),
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
    //withCredentials: true
};
export var widgetSourceFunctionApi = {
    baseURL: "https://apigen2-st3i2yb5oq-uc.a.run.app",
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
    //withCredentials: true
};
export var cancelToken = axios.CancelToken.source();
var Client = axios.create(clientConfig);
export default Client;
